/* eslint-disable import/no-named-as-default */
import ReleasesOverview from './ReleasesOverview';
import RequestForReleaseOverview from './RequestForReleaseOverview';
import OrderPremium from './OrderPremium';
import BargesOverview from './BargesOverview';
import DriversOverview from './DriversOverview';
import CreateTicket from './CreateTicket';
import Settings from './Settings';
import Loader from '../components/Loading';

export const ROUTES = [
  { 
    path: 'order', 
    component: OrderPremium,
    helpPage: 'order.html',
    title: 'navbar.order',
    category: 'profile',
    isProtected: true,
    onClick: () => { window.addToDataLayer('profilemenu','order') },
  },
  { 
    path: 'releases', 
    component: ReleasesOverview,
    helpPage: 'releasepage.html',
    title: 'navbar.overview',
    category: 'profile',
    isProtected: true,
    onClick: () => { window.addToDataLayer('profilemenu','releases') },
  },
  { 
    path: 'requests-for-release', 
    component: RequestForReleaseOverview,
    isProtected: true,
    title: 'req.for.release.navbar',
    category: 'profile',
    requiresFeature: 'canRequestForRelease',
    // helpPage: 'request-for-releasepage.html',
    onClick: () => { window.addToDataLayer('profilemenu','request-for-release') },
  },
  { 
    path: 'barges', 
    component: BargesOverview, 
    isProtected: true, 
    title: 'navbar.barges',
    category: 'profile',
    requiresFeature: 'canAssignBarge',
    onClick: () => { window.addToDataLayer('profilemenu', 'barges') },
  },
  { 
    path: 'drivers', 
    component: DriversOverview, 
    isProtected: true, 
    title: 'navbar.drivers',
    category: 'profile',
    requiresFeature: 'canAssignDriver',
    onClick: () => { window.addToDataLayer('profilemenu', 'drivers') },
  },
  {
    path: 'settings',
    component: Settings,
    helpPage: 'settings.html',
    title: 'navbar.settings',
    category: 'profile',
    isProtected: true,
    onClick: () => { window.addToDataLayer('profilemenu', 'settings') },
  },
  { path: 'loading', component: Loader },
  {
    path: '',
    component: ReleasesOverview,
    helpPage: 'releasepage.html',
    title: 'navbar.overview',
    // category: 'top',
    isProtected: true,
  },
  {
    path: '/',
    adminOnly: true,
    title: 'navbar.govApp',
    category: 'profile',
    isProtected: true,
    onClick: () => { window.addToDataLayer('profilemenu', 'govapp'); window.open(process.env.REACT_APP_GOV_APP_LINK) },
  },
  {
    path: '/',
    title: 'navbar.logout',
    category: 'profile',
    onClick: () => {
      window.addToDataLayer('profilemenu', 'logout');
      localStorage.clear();
      sessionStorage.clear()
      window.location.reload();
    },
  },
  { 
    path: 'ticket', 
    component: CreateTicket, 
    isProtected: true,
    onClick: () => { window.addToDataLayer('profilemenu','ticket') },

  },
];
